import { EmptyStatePush } from 'ui/illustrations';
import { PushContentDefinition } from 'modules/graphql/types';
import { Notification } from './Notification';
import {
  containerStyles,
  deviceStyles,
  deviceStylesCommon,
  deviceStylesUnset,
  messageUnset,
} from './styles';
import { PREVIEWER_CONTENT } from '../constants';
import { OS, PushPreviewType } from '../../common/types';
import { useEditableFieldsContext } from '../../context/EditableFieldsContext';
import { usePushPreviewContext } from '../context/PushPreviewContext';

type Props = {
  selectedOs: OS;
  selectedPreviewType: PushPreviewType;
};

export const Preview = ({ selectedOs, selectedPreviewType }: Props) => {
  /* only show the empty state if the message in the template data is not defined, even if the
   * message is a snippet which resolves to an empty string */
  const { hasContent, liveTemplate } = useEditableFieldsContext();
  const { previewError: hasPreviewError } = usePushPreviewContext();
  const pushData = (liveTemplate?.mediumData || {}) as PushContentDefinition;

  const emptyStateMessage = pushData.isSilentPush
    ? PREVIEWER_CONTENT.silentPushEnabledMessage
    : PREVIEWER_CONTENT.emptyMessage;

  const hidePreviewContent = !hasContent || pushData.isSilentPush || hasPreviewError;

  return (
    <div style={containerStyles}>
      <div
        data-test="template-editor-push-preview"
        style={{
          ...deviceStylesCommon,
          ...(hidePreviewContent ? deviceStylesUnset : deviceStyles[selectedOs]),
        }}
      >
        {hidePreviewContent ? (
          <>
            <EmptyStatePush data-test={'push-preview-empty-state'} />
            {!hasPreviewError && <div style={messageUnset}>{emptyStateMessage}</div>}
          </>
        ) : (
          <Notification selectedOs={selectedOs} selectedPreviewType={selectedPreviewType} />
        )}
      </div>
    </div>
  );
};

export default Preview;
